module.exports = __webpack_public_path__ + "static/media/tuggummi-min.9a1b555b.png";